import Vue from 'vue'
import VueRouter from 'vue-router'
import Wrapper from '../views2/Wrapper.vue'
import Section from '../views2/Section.vue'
import Lander from '../views2/Lander.vue'
import Quotes from '../views2/Quotes.vue'
import Videos from '../views2/Videos.vue'
import Page from '../views2/Page.vue'
import Updates from '../views2/Updates.vue'
import Item from '../views2/Item.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/nieuws',
    name: 'nieuws',
    component: Updates,
    props: true,
  },
  {
    path: '/quotes',
    name: 'quotes',
    component: Quotes,
    props: true,
  },
  {
    path: '/videos',
    name: 'videos',
    component: Videos,
    props: true,
  },
  {
    path: '/page/:slug',
    name: 'page',
    component: Page,
    props: true,
  },
  {
    path: '/:sectionHandle/:slug',
    name: 'item',
    component: Item,
    props: true,
  },
  {
    path: '/',
    component: Wrapper,
    props: true,
    children: [
      {
        path: '/:sectionHandle/',
        name: 'section',
        component: Section,
        props: true,
      },
      {
        path: '/',
        name: 'home',
        component: Lander,
        props: true,
      },
    ],
  },
  { path: '*', redirect: { name: 'home' } },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/' : '/',

  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.name === 'section') return { selector: '#section-links' }
    return { x: 0, y: 0 }
  },
})

export default router
